import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Row, Col } from 'antd'
import { IoIosArrowBack } from 'react-icons/io'
import { useThemeColors } from '../../ThemeContext'

const { Text } = Typography
const ArrowBackIcon = IoIosArrowBack as unknown as React.ComponentType<{
	style?: React.CSSProperties
	onClick?: () => void
}>

function CheckinCheckoutHeader() {
	const navigate = useNavigate()
	const { primary } = useThemeColors()

	const navToCheckinCheckoutPage = () => {
		navigate('/checkin-checkout')
	}

	return (
		<div
			style={{
				position: 'sticky',
				top: 0,
				zIndex: 1,
				width: '100%',
				background: primary,
				padding: '10px 20px',
			}}
		>
			<Row align='middle' justify='space-between'>
				<Col>
					<ArrowBackIcon
						style={{
							color: 'white',
							fontSize: '24px',
							cursor: 'pointer',
						}}
						onClick={navToCheckinCheckoutPage}
					/>
				</Col>
				<Col>
					<Text
						style={{
							color: 'white',
							fontSize: '24px',
							fontFamily: 'Times New Roman',
							textAlign: 'center',
							margin: '0 auto',
						}}
					>
						Attendance
					</Text>
				</Col>
			</Row>
		</div>
	)
}

export default CheckinCheckoutHeader
